export const BlogThreshold = {
  phone: '700px',
  tablet: '1200px'
}

export const colors = {
  main: '#933ec5',
  black: '#000000'
}
